import email from "./email.svg";
import resume from "./resume.png";
import linkedin from "./linkedin.png";
import github from "./github.svg";

const socials = [
  {
    name: "LinkedIn",
    icon: linkedin,
    link: "https://www.linkedin.com/in/edward-stump/",
  },
  { name: "Github", icon: github, link: "https://github.com/Eddie048" },
  {
    name: "Resume",
    icon: resume,
    link: "https://www.edwardstump.com/Resume_EdwardStump.pdf",
  },
  { name: "Email", icon: email, link: "mailto:ejstump13@gmail.com" },
];

export { socials };
